// 离线包加载失败保底
;(function (_window) {
  const DELAY = 4000
  const FLAGNAME = 'pgretry'
  const FLAG = 1
  const errorStatKey = 'offline_load_err'

  const utils = {
    getParamsObj: (location) => {
      const search = location.search
      if (!search) return {}

      let ret = null
      search.slice(1).split('&').forEach(item => {
        if (!ret) ret = {}
        ret[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
      })
      return ret
    }
  }


  try {
    const timer = setTimeout(() => {
      console.log('开始检测加载过程')
      clearTimeout(timer)
      const isDomReady = !!document.getElementById('app-content')

      // 1. 已挂载
      if (isDomReady) {
        console.log('已挂载dom主体')
        return
      }

      const urlObj = utils.getParamsObj(_window.location)

      // 2. 未挂载且已刷新过
      if (window.location.search.indexOf(FLAGNAME) >= 0) {
        console.log('已刷新页面重试2')
        // 跳转到粉丝说在线页
        const timerJumpOnline = setTimeout(() => {
          clearTimeout(timerJumpOnline)
          console.log('重定向到web2', `https://h5.kugou.com/apps/singer-qa-v2/${_window.location.hash}`)
          _window.location.href = `https://h5.kugou.com/apps/singer-qa-v2/${_window.location.hash}`
        }, 300)

        const img = new Image()
        img.src = `https://capture.kugou.com/performance/report/v1/collect/customize?sign=fensishuo&key=${errorStatKey}&onlinepage=1&ua=${
          encodeURIComponent(_window.navigator.userAgent)
        }`

        return
      }

      // 3. 未挂载
      const img = new Image()
      img.src = `https://capture.kugou.com/performance/report/v1/collect/customize?sign=fensishuo&key=${errorStatKey}&ua=${
        encodeURIComponent(_window.navigator.userAgent)
      }`


      let param = `${FLAGNAME}=1`
      if (_window.location.search.indexOf('?') >= 0) {
        param = '&' + param
      } else {
        param = '?' + param
      }
      console.log('reload页面2', `https://h5.kugou.com/apps/singer-qa-v2/${param}${_window.location.hash}`)

      const timerRedirect = setTimeout(() => {
        clearTimeout(timerRedirect)
        urlObj[FLAGNAME] = FLAG
        console.log('reload页面成功2', `https://h5.kugou.com/apps/singer-qa-v2/${param}${_window.location.hash}`)
        _window.location.href = `https://h5.kugou.com/apps/singer-qa-v2/${param}${_window.location.hash}`
      }, 300)

    }, DELAY)

  } catch (err) {
    const img = new Image()
    img.src = `https://capture.kugou.com/performance/report/v1/collect/customize?sign=fensishuo&key=${errorStatKey}&catch=1&ua=${
      encodeURIComponent(_window.navigator.userAgent)
    }`
  }

}(window))
